import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=e793f920&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=e793f920&prod&lang=scss"
import style1 from "./Case.vue?vue&type=style&index=1&id=e793f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e793f920",
  null
  
)

export default component.exports